if (!customElements.get('sophia-size-guide')) {
  customElements.define('sophia-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-size-guide-open]');
      this.trigger?.addEventListener('click', () => {
        if (!this.dialog?.open) this.dialog?.showModal();
      });
      this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog?.addEventListener('close', () => this.trigger?.focus());
    }
  });
}
